import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { FOOTER_MOBILE, HEADER_MOBILE } from '../../student-do-test/layouts/BottomNavigationLayout';
import { TestResultLayoutMobile } from '../layouts/TestResultLayoutMobile';
import { TestContentMobile } from './components/TestContentMobile';

const Content = styled.article`
  flex: 1;
  padding: ${16 + HEADER_MOBILE}px 0 ${FOOTER_MOBILE + 16}px 0;
`;

export const TestResultMobile = observer((props: any) => {
  return (
    <TestResultLayoutMobile {...props}>
      <Content id="test-result-content">
        <TestContentMobile id="body-container" />
      </Content>
    </TestResultLayoutMobile>
  );
});
